<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">{{name}}</h1>

                    <a v-if="!isDeleted" @click="handleDeleteConnectorCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa-regular fa-trash-can"></i>
                        Delete
                    </a>

                    <a v-else @click="handlePermanentDeleteConnectorCommandV1" role="button" class="btn btn-link btn-sm">
                        <i class="fa fa-remove" aria-hidden="true"></i>
                        Permanently delete
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <a :href="`/#/admin/integrations/connectors/configure/${id}`">Configure connector</a>&nbsp;<span>({{name}})</span><br />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import { useId } from '@common/composables'
    import { useRouter } from 'vue-router'
    import { useAdminConnectorDetailsPage } from '@Integrations/Connectors/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    const router = useRouter()
    const id = useId()

    const {
        useCurrentUserQuery,
        useConnectorDetailsQuery,
        useDeleteConnectorCommand,
        usePermanentDeleteConnectorCommand,
    } = useAdminConnectorDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorDetailsQueryV1, runConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const isDeleted = computed(() => modelConnectorDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteConnectorCommandV1, succeedDeleteConnectorCommandV1 } = useDeleteConnectorCommand(id, tid, userId)
    const { invokePermanentDeleteConnectorCommandV1, succeedPermanentDeleteConnectorCommandV1 } = usePermanentDeleteConnectorCommand(id)

    function handleDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to delete connector ${name.value}?`)) invokeDeleteConnectorCommandV1()
    }

    function handlePermanentDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete connector ${name.value}?`)) invokePermanentDeleteConnectorCommandV1()
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
    })

    watch(name, () => document.title = name.value)

    watch([succeedDeleteConnectorCommandV1], () => runConnectorDetailsQueryV1())

    watch(succeedPermanentDeleteConnectorCommandV1, (val) => val ? router.push(`/admin/integrations/connectors/manage/${tid.value}`) : null)
</script>
